export const patientMenuDef = [
    {
        name: 'menu.registration',
        icon: 'fa fa-user',
        data: {
            nav_url: "pre_registration_m"
        },
        children: [
            {
                name: 'menu.pre_registration',
                resource: 'pre_registration',
                icon: 'fa fa-user',
                url: 'pre_registration',
                auto_crud: true,
                showMenu: false,
                breadcrumb: 'Pre Registration'
            },
            {
                name: 'menu.pre_registration',
                resource: 'ivf_patient_registration',
                icon: 'fa fa-user',
                url: 'ivf_patient_registration',
                auto_crud: true,
                showMenu: false
            },
            {
                name: 'menu.ivf_patient',
                resource: 'ivf_patient',
                icon: 'fa fa-user',
                url: 'ivf_patient',
                auto_crud: true,
                showMenu: false
            },
            {
                name: 'menu.pre_registration',
                resource: 'temp_mr',
                icon: 'fa fa-user',
                url: 'temp_mr',
                auto_crud: true,
                showMenu: false,
                breadcrumb: 'Pre Registration'
            },
            {
                name: 'menu.selfRegistration',
                resource: 'self_registration',
                icon: 'fa fa-user',
                url: 'self_registration',
                auto_crud: true,
                showMenu: false,
                breadcrumb: 'Pre Registration'
            },
            {
                name: 'menu.patient_registration',
                resource: 'corporate_patient_add',
                icon: 'fa fa-user',
                url: 'corporate_patient_add',
                auto_crud: true,
                showMenu: false,
                breadcrumb: 'Patient List'
            },
            {
                name: 'menu.eligibility_form',
                resource: 'eligibility_form',
                icon: 'fa fa-plus-square',
                url: 'eligibility_form',
                check_permission: false,
                auto_crud: true,
                showMenu: true
            },
            {
                name: 'menu.patient_registration',
                resource: 'patient',
                icon: 'fa fa-user',
                url: 'patient',
                auto_crud: true,
                showMenu: false,
                breadcrumb: 'Patient List'
            },   
            {
                name: 'menu.couple_registration',
                resource: 'couple_registration_form',
                icon: 'fa fa-user',
                url: 'couple_registration_form',
                auto_crud: true,
                showMenu: false,
                breadcrumb: 'Patient List'
            },   
            {
                name: 'menu.patient_registration',
                resource: 'patient_tab',
                icon: 'fa fa-plus-square',
                url: 'patient_tab',
                auto_crud: true,
                breadcrumb: 'patient_tab',
                check_permission: false
            },
            {
                name: 'menu.family_member_detail_tab',
                resource: 'family_member_detail_tab',
                icon: 'fa fa-plus-square',
                url: 'family_member_detail_tab',
                auto_crud: true,
                breadcrumb: 'family_member_detail_tab',
                check_permission: false
            }, 
            {
                name: 'menu.patient_update',
                resource: 'patient_update',
                icon: 'fa fa-user',
                url: 'patient_update',
                auto_crud: true,
                showMenu: false,
                breadcrumb: 'Patient Update'
            },
            {
                name: 'menu.patient_current_facility',
                resource: 'patient_current_facility',
                icon: 'fa fa-user',
                url: 'patient_current_facility',
                auto_crud: true,
                showMenu: false,
                breadcrumb: 'Patient Current Facility Update'
            },
            {
                name: 'menu.patient_block_events',
                resource: 'patient_block_events',
                icon: 'fa fa-user',
                url: 'patient_block_events',
                auto_crud: true,
                showMenu: false,
                breadcrumb: 'Patient Block Events'
            },
            {
                name: 'menu.telecom_update',
                resource: 'telecom_update',
                icon: 'fa fa-user',
                url: 'telecom_update',
                auto_crud: true,
                showMenu: false,
                breadcrumb: 'Patient Telecom Update'
            },
            {
                name: 'menu.patient_update',
                resource: 'patient_profile_update_disabled_field',
                icon: 'fa fa-user',
                url: 'patient_profile_update_disabled_field',
                auto_crud: true,
                showMenu: false,
                breadcrumb: 'Patient Update'
            },
            {
                name: 'menu.patient_update',
                resource: 'patient_profile_update',
                icon: 'fa fa-user',
                url: 'patient_profile_update',
                auto_crud: true,
                showMenu: false,
                breadcrumb: 'Patient Update'
            },
            {
                name: 'menu.patient_update',
                resource: 'patient_profile_details_update',
                icon: 'fa fa-user',
                url: 'patient_profile_details_update',
                auto_crud: true,
                showMenu: false,
                breadcrumb: 'Patient Update'
            },
            {
                name: 'menu.pre_registration_update',
                resource: 'pre_registration_update',
                icon: 'fa fa-user',
                url: 'pre_registration_update',
                auto_crud: true,
                showMenu: false,
                breadcrumb: 'Pre Registration Update'
            },
            {
                name: 'menu.temp_mr_update',
                resource: 'temp_mr_update',
                icon: 'fa fa-user',
                url: 'temp_mr_update',
                auto_crud: true,
                showMenu: false,
                breadcrumb: 'Temp Registration Update'
            },
            {
                name: 'menu.patient_uhid_merge',
                resource: 'patient_uhid_merge',
                icon: 'fa fa-user',
                url: 'patient_uhid_merge',
                auto_crud: true,
                breadcrumb: 'Patient UhId Merge',
                showMenu: false
            },
            {
                name: 'menu.patient_activate_deactivate_uhid',
                resource: 'patient_activate_deactivate_uhid',
                icon: 'fa fa-user',
                url: 'patient_activate_deactivate_uhid',
                auto_crud: true,
                breadcrumb: 'Patient Activate/Deactivate',
                showMenu: false
            },
            {
                name: 'menu.patient_deactivation_details',
                resource: 'patient_deactivation_details',
                icon: 'fa fa-superpowers',
                url: 'patient_deactivation_details',
                auto_crud: true,
                breadcrumb: 'View Patient Deactivation Details',
                showMenu: false
            }
        ]
    }
]